import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

export default function swipers() {

    // ----------------------------------------------
    // Cities galleries with lightbox swiper
    // ----------------------------------------------

    const galleryLightboxImage = document.querySelector('.js-gallery-lightbox-slider-image');
    const galleryLightboxText = document.querySelector('.js-gallery-lightbox-slider-text');
    const galleryLightboxNav = document.querySelector('.js-gallery-lightbox-nav');

    if(galleryLightboxImage && galleryLightboxText){

        window.addEventListener('DOMContentLoaded', () => {

            const swipperLightboxImg = new Swiper(galleryLightboxImage, {
                navigation: {
                    prevEl: galleryLightboxNav?.children[0],
                    nextEl: galleryLightboxNav?.children[1],
                },
                autoHeight: true,
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 0,
                speed: 1200,
                loop: true,
                allowTouchMove: false,
                observer: true,
                on: {
                    // slideChange: function (){
                    slideChangeTransitionEnd: function (){
                        // setTimeout(() => {


                            // const slide = this.$el.find('.swiper-slide-active div');
                            const slide = this.el.querySelectorAll('.swiper-slide-active div')
                            // const slide = this.slides[this.activeIndex].querySelectorAll('.swiper-slide-active div')
                            const gallery = slide[0] ? slide[0].getAttribute('data-gallery') : '';
                            const hover = document.querySelector('.js-gallery-lightbox-hover');
                            const imgSliderMain = document.querySelector('.js-gallery-lightbox-slider-image');

                            if(gallery === 'true'){
                                hover.style.opacity = 1;
                                imgSliderMain.classList.add('cursor-none');
                            }else{
                                hover.style.opacity = 0;
                                imgSliderMain.classList.remove('cursor-none');
                            }

                        // },200);
                    }
                }
            });

            /// This need get tag h2 width to full center slide
            const fixSlides = () => {
                const galleryLightboxText = document.querySelector('.js-gallery-lightbox-slider-text');
                const slides = galleryLightboxText.querySelectorAll('.swiper-slide');

                for(let slide of slides){
                    slide.style.width = slide.querySelector('h2').clientWidth + 'px';
                }
            }

            window.addEventListener('load', fixSlides());
            //window.addEventListener('resize', fixSlides);
setTimeout(() => {
    
    const swipperLightboxText = new Swiper(galleryLightboxText, {
        navigation: {
            prevEl: galleryLightboxNav?.children[0],
            nextEl: galleryLightboxNav?.children[1],
        },
        autoHeight: false,
        slidesPerView: "auto",
        centeredSlides: window.innerWidth < 1280,
        spaceBetween: 0,
        speed: 1200,
        loop: true,
        allowTouchMove: false,
        observer: true,
    });

}, 1000);
            //swipperLightboxImg.controller.control = swipperLightboxText;

        });

    }

    // end Cities galleries with lightbox swiper

    // ----------------------------------------------
    // Capsule type sliders
    // ----------------------------------------------

    const capsuleSliders = document.querySelectorAll('.js-capsule-slider');

    if (capsuleSliders) {

        for(const capsuleSlider of capsuleSliders){

            const capsuleSliderNav = capsuleSlider.parentElement.querySelector('.js-capsule-slider-nav');

            new Swiper(capsuleSlider, {
                navigation: {
                    prevEl: capsuleSliderNav?.children[0],
                    nextEl: capsuleSliderNav?.children[1],
                },
                loop: true,
                // centeredSlides: false,
                breakpoints: {
                300: {
                    spaceBetween: 10,
                    slidesPerView: 1.8,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
                1025: {
                    spaceBetween: 40,
                    centeredSlides: false,
                    slidesPerView: 4,
                },
                },
            });
        }
    }    
    
    
    // ----------------------------------------------
    // Related rooms slider
    // ----------------------------------------------

    const relateRoomsSliders = document.querySelectorAll('.js-related-rooms-slider');

    if (relateRoomsSliders) {

        for(const relateRoomsSlider of relateRoomsSliders){

            const relatedRoomsSliderPagination = relateRoomsSlider.parentElement.querySelector('.js-related-rooms-slider-nav');
            const relatedRoomsSliderNav = relateRoomsSlider.querySelector('.js-related-rooms-slider-navigation');

            new Swiper(relateRoomsSlider, {
                navigation: {
                    prevEl: relatedRoomsSliderPagination?.children[0],
                    nextEl: relatedRoomsSliderPagination?.children[1],
                },
                loop: false,
                breakpoints: {
                    300: {
                        spaceBetween: 20,
                        slidesPerView: 1,
                    },
                    768: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                    },
                    1025: {
                        spaceBetween: 20,
                        slidesPerView: 3,
                    },
                },
                pagination: {
                    el: relatedRoomsSliderNav,
                    type: 'bullets',
                    clickable: true,
                },
            });
        }
    }   
    
    // ----------------------------------------------
    // rooms slider
    // ----------------------------------------------

    const roomsSliders = document.querySelectorAll('.js-room-gallery');

    if (roomsSliders) {

        for(const roomsSlider of roomsSliders){

            const roomsSliderPagination = roomsSlider.querySelector('.js-room-gallery-pagination');
            const roomsSliderNav = roomsSlider.querySelector('.js-room-gallery-navigation');

            new Swiper(roomsSlider, {
                navigation: {
                    prevEl: roomsSliderNav?.children[0],
                    nextEl: roomsSliderNav?.children[1],
                },
                loop: true,
                slidesPerView: 1,
                effect: 'fade',
                speed: 300,
                pagination: {
                    el: roomsSliderPagination,
                    type: 'bullets',
                    clickable: true,
                },
            });
        }
    }

    // end Capsule type sliders


    const newsSliders = document.querySelectorAll('.js-news-mobile-slider');

    if (newsSliders) {

        for(const newsSlider of newsSliders){

            const newsSliderPagination = newsSlider.querySelector('.js-news-mobile-slide-pagination');

            new Swiper(newsSlider, {
                loop: true,
                slidesPerView: 1,
                effect: 'fade',
                speed: 300,
                pagination: {
                    el: newsSliderPagination,
                    type: 'bullets',
                    clickable: true,
                },
            });
        }
    }

    // ----------------------------------------------
    // Single rooms slider
    // ----------------------------------------------

    const singleSliders = document.querySelectorAll('.js-single-gallery-slider');
    const tabNavigations = document.querySelectorAll('.js-tab-nav');

    if (singleSliders) {

        //const singleNav = singleSliders[0].parentElement.querySelector('.js-gallery-nav');

        // const swiperOptions = {
        //     navigation: {
        //         prevEl: singleNav?.children[0],
        //         nextEl: singleNav?.children[1],
        //     },
        //     //centeredSlides: true,
        //     //freeMode: true,
        //     //freeModeMomentumBounce: false,
        //     //freeModeMomentumRatio: .1,
        //     //freeModeMomentumVelocityRatio: .8,
        //     //freeModeSticky: true,
        //     //grabCursor: true,
        //     //loop: false,
        //     //loopAdditionalSlides: 2 * 2,
        //     //loopedSlides: 100,
        //     slidesPerView: 'auto',
        //     speed: 1000,
        //     breakpoints: {
        //         300: {
        //             spaceBetween: 2,
        //         },
        //         768: {
        //             spaceBetween: 4,
        //         },
        //         1025: {
        //             spaceBetween: 4,
        //         },
        //     },
        // };

        for(const singleSlider of singleSliders){

            //const singleNav = singleSlider.parentElement.querySelector('.js-gallery-nav');
            // const swiperOptions = {
            //     loop: true,
            //     freeMode: true,
            //     grabCursor: true,
            //     slidesPerView: 'auto',
            //     loop: true,
            //     autoplay: {
            //       delay: 1,
            //       disableOnInteraction: true
            //     },
            //     freeMode: true,
            //     speed: 5000,
            //     freeModeMomentum: false,
            //     observer: true,
            //     observeParents: true,
            //     breakpoints: {
            //         300: {
            //             spaceBetween: 2,
            //         },
            //         768: {
            //             spaceBetween: 4,
            //         },
            //         1025: {
            //             spaceBetween: 4,
            //         },
            //     },
            //   };

            // const singleSwiperGet = new Swiper(singleSlider, swiperOptions);

            // singleSlider.addEventListener('mouseenter', () => {
            //     //singleSwiperGet.autoplay.stop();
            // });

            // singleSlider.addEventListener('mouseleave', () => {
            //     //singleSwiperGet.autoplay.start();
            // });

            //const singleSwiperGet = new Swiper(singleSlider, swiperOptions);


            const singleNav = singleSlider.parentElement.parentElement.querySelector('.js-gallery-nav');

            const swiperNavOptions = {
                navigation: {
                    prevEl: singleNav?.children[0],
                    nextEl: singleNav?.children[1],
                },
                centeredSlides: true,
                // freeMode: true,
                slidesPerView: 'auto',
                speed: 1000,
                breakpoints: {
                    300: {
                        spaceBetween: 2,
                    },
                    768: {
                        spaceBetween: 4,
                    },
                    1025: {
                        spaceBetween: 4,
                    },
                },
                on: {
                    slideChangeTransitionEnd: function() {
                        this.slides.forEach(slide => {
                            const video = slide.querySelector('video');
                            if (video) {
                                video.removeAttribute('controls');
                                video.pause();
                            }
                        });

                        const activeSlide = this.slides[this.activeIndex];
                        const activeVideo = activeSlide.querySelector('video');

                        if (activeVideo) {
                            setTimeout(() => {
                                activeVideo.setAttribute('controls', 'controls');
                            }, 10);
                        }
                    }
                }
            }

            const slider = new Swiper(singleSlider, swiperNavOptions);

            slider.update(true);

            // singleSlider.addEventListener('mouseleave', () => {
            //     singleSwiperGet.autoplay.start();
            // });
        }

        for(const navlink of tabNavigations){

            const getLinkButtons = document.querySelectorAll('.js-button-link-to-room');

            if(getLinkButtons){
                setTimeout(function(){
                    if(navlink.classList.contains('active')){
                        for(const button of getLinkButtons){
                            button.setAttribute('href', navlink.getAttribute('data-link'));
                        }
                    }
                },1500);
       
            }

            navlink.addEventListener('click', () => {

                const getLink = navlink.getAttribute('data-link');
                const getID = navlink.getAttribute('data-tab');
                const swiperID = document.getElementById(getID);
                const singleSlider = swiperID.querySelector('.js-single-gallery-slider');
                singleSlider.destroy;
                //singleSlider.update(true);

                const singleNav = singleSlider.parentElement.parentElement.querySelector('.js-gallery-nav');

                const swiperNavOptions = {
                    navigation: {
                        prevEl: singleNav?.children[0],
                        nextEl: singleNav?.children[1],
                    },
                    //centeredSlides: true,
                    freeMode: true,
                    slidesPerView: 'auto',
                    speed: 1000,
                    breakpoints: {
                        300: {
                            spaceBetween: 2,
                        },
                        768: {
                            spaceBetween: 4,
                        },
                        1025: {
                            spaceBetween: 4,
                        },
                    },
                }

                new Swiper(singleSlider, swiperNavOptions);
                //const singleSwiperGet = new Swiper(singleSlider, swiperOptions);

                // singleSlider.addEventListener('mouseleave', () => {
                //     singleSwiperGet.autoplay.start();
                // });

                if(getLinkButtons){
                    for(const button of getLinkButtons){
                        button.setAttribute('href', getLink);
                    }
                }

            });
        }
    }

    // end Single rooms slider



}